import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  constructor(private http: HttpClient, private router: Router) { }

  getAvailabilities(date: string) {
    return this.http.get<[{time: string; slotsAvailable: number}]>('http://localhost:3000/api/schedule/availabilities');
  }

  checkAvailabilitie(date: string, calendar: number) {
    return this.http.post<{
        datetime: string;
        appointmentTypeID: number,
        calendarID: number,
        valid: boolean
    }>('http://localhost:3000/api/schedule/check',
    {
      datetime: date,
      appointmentTypeID: 14788382,
      calendarID: calendar
    });
  }

  bookTimeslot(date: string, firstName: string, lastName: string, email: string, calendar: number)  {
    return this.http.post('http://localhost:3000/api/schedule/book',
      {
        datetime: date,
        firstName,
        lastName,
        email,
        appointmentTypeID: 14788382,
        calendarID: calendar
      });
  }
}
